import {DateRangeType} from 'common/types/reports/bookmark';

import {DateRange} from './date-range';
import {PresetDateRange} from './presets';

export class InsightsTimePickerDateRange extends DateRange {
  public static get presets(): PresetDateRange[] {
    return [
      PresetDateRange.Today,
      PresetDateRange.Yesterday,
      PresetDateRange.Last96Hours,
      PresetDateRange.Last30Days,
      PresetDateRange.Last24Weeks,
      PresetDateRange.Last12Months,
      PresetDateRange.WeekToDate,
      PresetDateRange.MonthToDate,
      PresetDateRange.QuarterToDate,
      PresetDateRange.YearToDate,
    ];
  }

  public canUseRolling(): boolean {
    return [DateRangeType.Between, DateRangeType.On].includes(this.type);
  }
}
